<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "BusinessUnitWrapper"
    }
</script>

<style scoped>

</style>